import { createFileRoute } from '@tanstack/react-router';
import { PromptBuilder } from '@/components/agents/prompt-builder';

export const Route = createFileRoute('/_dashboard/agents/create/ai')({
  component: PromptBuilderPage,
});

function PromptBuilderPage() {
  return <PromptBuilder />;
}
